(function () {
  if (window.__badmonPersistentNavigationInitialized) return;
  window.__badmonPersistentNavigationInitialized = true;

  const CONTENT_SELECTOR = "#AjaxPageContent";
  let currentAbortController = null;

  function isInternalLink(url) {
    try {
      return new URL(url, window.location.origin).origin === window.location.origin;
    } catch {
      return false;
    }
  }

  function shouldHandleLink(link) {
    if (!link || !link.href) return false;
    if (link.target === "_blank") return false;
    if (link.hasAttribute("download")) return false;
    if (link.dataset.noAjax !== undefined) return false;
    if (!isInternalLink(link.href)) return false;

    const url = new URL(link.href, window.location.origin);
    const samePage =
      url.hash &&
      url.pathname === window.location.pathname &&
      url.search === window.location.search;

    return !samePage;
  }

  async function fetchPage(url, signal) {
    const response = await fetch(url, {
      method: "GET",
      credentials: "same-origin",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      signal
    });

    if (!response.ok) throw new Error("Failed to fetch page: " + response.status);

    return { html: await response.text(), finalUrl: response.url };
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, "text/html");
  }

  function updateTitle(doc) {
    const title = doc.querySelector("title");
    if (title) document.title = title.textContent;
  }

  function updateBodyClass(doc) {
    if (doc.body) document.body.className = doc.body.className;
  }

  async function hoistStylesheets(doc) {
    const incoming = doc.querySelector(CONTENT_SELECTOR);
    if (!incoming) return;

    const existingHrefs = new Set(
      Array.from(document.head.querySelectorAll('link[rel="stylesheet"]'), (l) => l.href)
    );

    const waits = [];
    incoming.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
      if (!existingHrefs.has(link.href)) {
        const newLink = link.cloneNode(true);
        waits.push(new Promise((resolve) => {
          newLink.addEventListener('load', resolve, { once: true });
          newLink.addEventListener('error', resolve, { once: true });
        }));
        document.head.appendChild(newLink);
      }
      link.remove();
    });
    await Promise.all(waits);
  }

  function replaceAjaxContent(doc) {
    const current = document.querySelector(CONTENT_SELECTOR);
    const incoming = doc.querySelector(CONTENT_SELECTOR);

    if (!current || !incoming) throw new Error("Ajax page wrapper not found.");

    current.replaceChildren(...Array.from(incoming.childNodes));
  }

  function runScriptsInside(container) {
    container.querySelectorAll("script").forEach((oldScript) => {
      const newScript = document.createElement("script");

      Array.from(oldScript.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });

      if (oldScript.src) {
        newScript.src = oldScript.src;
      } else {
        newScript.textContent = oldScript.textContent;
      }

      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  async function navigate(url, pushStateEntry) {
    if (currentAbortController) currentAbortController.abort();
    currentAbortController = new AbortController();
    const { signal } = currentAbortController;
    const rootEl = document.documentElement;

    try {
      rootEl.classList.add("is-page-loading");

      const { html, finalUrl } = await fetchPage(url, signal);
      const doc = parseHTML(html);

      updateTitle(doc);
      updateBodyClass(doc);
      await hoistStylesheets(doc);
      replaceAjaxContent(doc);

      runScriptsInside(document.querySelector(CONTENT_SELECTOR));

      if (pushStateEntry) history.pushState({ url: finalUrl }, "", finalUrl);

      window.scrollTo(0, 0);
      document.dispatchEvent(new CustomEvent("badmon:page:loaded"));
    } catch (error) {
      if (error.name === "AbortError") return;
      console.warn("AJAX navigation failed, falling back to normal navigation.", error);
      window.location.href = url;
    } finally {
      rootEl.classList.remove("is-page-loading");
    }
  }

  document.addEventListener("click", (event) => {
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest("a");
    if (!shouldHandleLink(link)) return;

    event.preventDefault();
    navigate(link.href, true);
  });

  window.addEventListener("popstate", () => {
    navigate(window.location.href, false);
  });
})();
